import { extractVariantNumber } from 'src/actions/rewards'
import { LineItem } from 'src/types/cart'
/**
 * Converts a cart lineitems to an array of product slugs
 */

export function convertLineItemsToSlugs(lineItems: LineItem[], productMap: any) {
  return lineItems.map((item) => {
    const fullVariantId = item.node.merchandise.id
    const variantId = extractVariantNumber(fullVariantId)
    const slug = productMap?.byVariantId?.[variantId]?.slug
    return slug
  })
}
